import _styled, { default as _styled2 } from "styled-components";
var _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import "core-js/modules/web.dom-collections.iterator.js";
import i18next from "i18next";
import { runInAction } from "mobx";
import isDefined from "../../Core/isDefined";
import Collapsible from "../Custom/Collapsible/Collapsible";
import parseCustomMarkdownToReact from "../Custom/parseCustomMarkdownToReact";
import Text, { TextSpan } from "../../Styled/Text";
import { RawButton } from "../../Styled/Button";
import Spacing from "../../Styled/Spacing";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const shareConvertNotification = messages => function shareConvertNotification(viewState) {
  const messagesForPath = {};
  messages === null || messages === void 0 || messages.forEach(message => {
    var _message$path;
    let pathString = (_message$path = message.path) === null || _message$path === void 0 ? void 0 : _message$path.join(": ");
    if (!pathString || pathString === null || pathString === "") pathString = "root";
    if (isDefined(messagesForPath[pathString])) {
      messagesForPath[pathString].push(message.message);
    } else {
      messagesForPath[pathString] = [message.message];
    }
  });
  const rootMessages = messagesForPath["root"];
  delete messagesForPath["root"];
  const showHelp = () => {
    viewState.showHelpPanel();
    viewState.selectHelpMenuItem("storymigration");
    viewState.terria.notificationState.dismissCurrentNotification();
  };
  const showFeedback = () => {
    runInAction(() => {
      viewState.feedbackFormIsVisible = true;
    });
    viewState.terria.notificationState.dismissCurrentNotification();
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      children: parseCustomMarkdownToReact(i18next.t("share.convertNotificationMessage"))
    }), /*#__PURE__*/_jsx(_StyledRawButton, {
      fullWidth: true,
      onClick: showHelp,
      children: /*#__PURE__*/_jsx(TextSpan, {
        textLight: true,
        bold: true,
        medium: true,
        isLink: true,
        children: parseCustomMarkdownToReact(i18next.t("share.convertNotificationHelp"))
      })
    }), /*#__PURE__*/_jsx(_StyledRawButton2, {
      fullWidth: true,
      onClick: showFeedback,
      children: /*#__PURE__*/_jsx(TextSpan, {
        textLight: true,
        bold: true,
        medium: true,
        isLink: true,
        children: parseCustomMarkdownToReact(i18next.t("share.convertNotificationFeedback"))
      })
    }), /*#__PURE__*/_jsx(Spacing, {
      bottom: 2
    }), /*#__PURE__*/_jsxs(Collapsible, {
      btnRight: true,
      title: i18next.t("share.convertNotificationWarningsTitle"),
      titleTextProps: {
        large: true
      },
      bodyBoxProps: {
        padded: true
      },
      children: [rootMessages && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("ul", {
          children: rootMessages.map((message, i) => /*#__PURE__*/_jsx("li", {
            children: message
          }, i))
        }), /*#__PURE__*/_jsx(Spacing, {
          bottom: 1
        })]
      }), Object.entries(messagesForPath).map(_ref => {
        let [path, messages] = _ref;
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Spacing, {
            bottom: 1
          }), /*#__PURE__*/_jsx(Collapsible, {
            btnRight: true,
            title: path && path !== "" ? path : i18next.t("share.convertNotificationWarningsTitle"),
            children: /*#__PURE__*/_jsx("ul", {
              children: messages.map((message, i) => /*#__PURE__*/_jsx("li", {
                children: message
              }, i))
            })
          })]
        });
      })]
    })]
  });
};
var _StyledRawButton = _styled(RawButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            text-align: left;\n          "])));
var _StyledRawButton2 = _styled2(RawButton).withConfig({
  displayName: "shareConvertNotification___StyledRawButton2",
  componentId: "sc-osai22-0"
})(["text-align:left;"]);